import Dashboard from './Dashboard'

export default Dashboard


// WEBPACK FOOTER //
// ./src/modules/Dashboard/Components/index.js